function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3009",
  "data-name": "Group 3009",
  transform: "translate(22811 -7494)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_139",
  "data-name": "Ellipse 139",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(-22811 7494)",
  fill: "rgba(161,164,172,0.2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "description_FILL1_wght400_GRAD0_opsz48_1_",
  "data-name": "description_FILL1_wght400_GRAD0_opsz48 (1)",
  d: "M11.479,15.6H16.3a.552.552,0,1,0,0-1.1H11.479a.552.552,0,1,0,0,1.1Zm0-3.129H16.3a.552.552,0,1,0,0-1.1H11.479a.552.552,0,1,0,0,1.1ZM9.1,18.727a1.132,1.132,0,0,1-1.1-1.1V5.1A1.132,1.132,0,0,1,9.1,4H15.29a1.1,1.1,0,0,1,.792.331L19.45,7.7a1.1,1.1,0,0,1,.331.792v9.131a1.132,1.132,0,0,1-1.1,1.1Zm6.646-10.2h2.927L15.2,5.1V7.976a.535.535,0,0,0,.552.552Z",
  transform: "translate(-22808.891 7498.636)",
  fill: "#00cd98"
}));

var SvgSupportingDocuments = function SvgSupportingDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSupportingDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/supporting-documents.d686457d.svg";
export { ForwardRef as ReactComponent };